import React from "react";

// Live character counter for length-limited fields. Its own file so Edit
// Profile's Bio and Background / Education fields can show their limit the same
// way the league creation screens do, without pulling in the wizard's editor.
const Counter = ({ value, max }) => {
  const used = (value || "").length;
  const atLimit = used >= max;
  return (
    <span
      className={`pointer-events-none absolute bottom-2 right-3 text-[11px] tabular-nums ${
        atLimit ? "text-[#A67C00]" : "text-tertiary"
      }`}
    >
      {used}/{max}
    </span>
  );
};

export default Counter;
